/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update an existing claim folder
 * @export
 * @interface UpdateClaimFolderRequest
 */
export interface UpdateClaimFolderRequest {
    /**
     * Folder name
     * @type {string}
     * @memberof UpdateClaimFolderRequest
     */
    name?: string;
    /**
     * Optional hex color code for folder display (e.g., "#3B82F6")
     * @type {string}
     * @memberof UpdateClaimFolderRequest
     */
    color?: string | null;
}

/**
 * Check if a given object implements the UpdateClaimFolderRequest interface.
 */
export function instanceOfUpdateClaimFolderRequest(value: object): value is UpdateClaimFolderRequest {
    return true;
}

export function UpdateClaimFolderRequestFromJSON(json: any): UpdateClaimFolderRequest {
    return UpdateClaimFolderRequestFromJSONTyped(json, false);
}

export function UpdateClaimFolderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimFolderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'color': json['color'] == null ? undefined : json['color'],
    };
}

export function UpdateClaimFolderRequestToJSON(json: any): UpdateClaimFolderRequest {
    return UpdateClaimFolderRequestToJSONTyped(json, false);
}

export function UpdateClaimFolderRequestToJSONTyped(value?: UpdateClaimFolderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'color': value['color'],
    };
}

